import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { DossierMetadataForm } from "@/components/DossierMetadataForm";
import { PageTitle } from "@/components/PageTitle";
import { BackButton } from "@/components/ui/BackButton";
import { RespondentsForDossier } from "@/features/RespondentEditor/queries";
import { useTranslation } from "@/i18n/client";
import { isMetadata } from "@/models/dossier";
import { useSessionContext } from "@/session";

export const Route = createFileRoute("/$organizationKey/$dossierId/dossier/metadata")({
  component: Page,
});

function Page() {
  const { organizationKey, dossierId } = useSessionContext();
  const { t } = useTranslation("RespondentEditor");
  const { data } = useSuspenseQuery(RespondentsForDossier, {
    variables: { organizationKey, dossierId },
  });

  const metadata = data.currentDossier.metadata;

  if (isMetadata(metadata)) {
    return (
      <>
        <PageTitle title="metadata" />
        <Section variant="header">
          <SectionHeader
            header={t("metadata")}
            buttons={<BackButton href="/$organizationKey/$dossierId/dossier" />}
          />
        </Section>

        <Section>
          <DossierMetadataForm
            metadataFields={data.organization.dossierMetadataFieldDefinitions}
            metadata={metadata}
          />
        </Section>
      </>
    );
  } else {
    return null;
  }
}
